// import { WebStorageStateStore } from "oidc-client";

export const environment = {
  api_uri: 'https://localhost:44390',
  api_version: 'v1',
  production: false,

  app_name: "myESAIC",
  auth: {
    authority: "https://qa.auth.esaic.key4.events",
    client_id: "2967226d-a47b-4b7a-b165-6c09198a081d",
    redirect_uri: "http://localhost:4200/auth-callback",
    response_type: "code",
    scope: "openid profile roles AEE.Api",
    filterProtocolClaims: true,
    loadUserInfo: true
  },
  customFields: {
    identifierName: ""
  }
};
